/**
 * @internal
 */
export var ProductTypeUrlParameter = {
    Family: 'familyIds',
    Group: 'groupIds',
    Product: 'productIds',
};
